import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  jGroupActions,
  resetForm,
  setDialog,
} from "../../../../app/slices/jomla/jGroupSlice";
import {
  HiOutlineRectangleGroup,
  HiOutlineIdentification,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const JGroupForm = () => {
  const jGroup = useSelector((state) => state.jGroup.jGroup);
  const _SearchBody = useSelector((state) => state.jGroup.searchBody);
  // const _provinces = useSelector((state) => state.provinces.provinces.data);

  const isAdd = jGroup.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: jGroup.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(jGroupActions.create(data, _SearchBody));
    } else {
      dispatch(jGroupActions.update(data.id, data, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ...jGroup.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jGroup.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    // <Typography>form test</Typography>
    <FormDialog
      open={jGroup.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineRectangleGroup />}
      title={isAdd ? "إضافة مجموعة" : "تعديل المجموعة"}
      subtitle={
        isAdd
          ? "أدخل اسم المجموعة لإضافتها"
          : "قم بتحديث معلومات المجموعة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات المجموعة">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label=" الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JGroupForm;
